import { parseCookies } from "utils/nookies";
import {CookiesConstants, CustomThemeConstants} from "utils/constants";
import {
  linkToAreaGuideOpensooq,
  linkToBlogOpensooq,
  linkToChooseCountry, linkToCommercialDaleel,
  linkToCrafts,
  linkToCurrencyRates, linkToMedicleDaleel,
  linkToPalestineRadios, linkToPalestinianGrades, linkToPalestinianUniversities,
  linkToReadOpensooq,
  linkToUniversities,
  linkToVaccinations,
} from "./home";
import { linkPrayerTimes } from "./prayerTimes";
import { linkWeather } from "./weather";
import { linkToTagsPage } from "./tags";
import { linkToCarPricesSpecs } from "./carPricesSpecsLinks";
import { linkMobileTabletPrices } from "./mobileTabletPrices";
import { linkToRealEstatePrices } from "./realEstatePrices";
import { linkToBuyRentComparisonCalculator } from "./buyRentComparisonCalculator";
import { linkToSiteMapPage } from "./siteMapPage";
import { linkToOpenSooqLogo } from "./openSooqLogo";
import { linkToSupport } from "./help";
import { linkToLoanCalculator } from "./loanCalculator";
import { linkToAdvertisingProducts } from "helpers/links-builders/advertisingProducts";
import { linkToPaymentMethod } from "helpers/links-builders/paymentMethodLink";
import { linkToAboutUs } from "helpers/links-builders/aboutUs";
import { linkToAutoServiceCenters } from "helpers/links-builders/autoServiceCenters";
import { AccordionItemType } from "componentLayout/MobileFooter/MobileBottomMenu";
import {getCustomThemeValue} from "helpers/osHelpers";
import {
  isCarseerAvilableinthisCountry,
  isMojazAvilableinthisCountry
} from "componentScreens/CarReportsPage/helpers/carReportsHelper";
import {linkToBrandsPage} from "helpers/links-builders/brands";
import {
  linkToCarfax,
  linkToCarseer, linkToMojaz,
} from "helpers/links-builders/carReportsLinkBuilders";
import {
  linkToSellAnything
} from "../../screens/seller-pages/_private/SellerPagesLinks";
import {linkToTopSoldCars} from "../../screens/TopSoldCars/_private/components/TopSoldCarsLink";
import {ICountryAssetLite} from "models/Assets/ICountryAsset";
import {labelHelper} from "helpers/themeHelpers";

export const footerOtherLinks = (
  translations: any,
  locale: any,
  country: string,
  fullCountryName:ICountryAssetLite
): AccordionItemType[] => {
  let linksList = [
    {
      id:0,
      linkText: translations.footer.sellAnything,
      linkUrl: linkToSellAnything(),
    },
    {
      id: 1,
      linkText: translations.footer.mostFamousCarsSoldiNOpenSooq?.replace('__market_name__' ,labelHelper(fullCountryName)),
      linkUrl: linkToTopSoldCars(),
    },
    isMojazAvilableinthisCountry(country) && {
      id: 0,
      linkText: translations.footer.mojaz,
      linkUrl: linkToMojaz(),
    },
    isCarseerAvilableinthisCountry(country) && {
      id: 0,
      linkText: translations.footer.carseer,
      linkUrl: linkToCarseer(),
    },
    {
      id: 2,
      linkText: translations.footer.tags,
      linkUrl: linkToTagsPage(locale),
    },
    {
      id: 3,
      linkText: translations.footer.autos,
      linkUrl: linkToAutoServiceCenters(),
    },
    {
      id: 12,
      linkText: translations.footer.prayerTimes,
      linkUrl: linkPrayerTimes(country),
      target: (process.env.NEXT_PUBLIC_CUSTOM_THEME==="shobiddak"  || country === "ps" ) ? '_blank':'_self'
    },
    {
      id: 13,
      linkText: translations.footer.weather,
      linkUrl: linkWeather(null, country),
      target: (process.env.NEXT_PUBLIC_CUSTOM_THEME==="shobiddak"  || country === "ps" ) ? '_blank':'_self'
    },
    {
      id: 14,
      linkText: translations.footer.carfax,
      linkUrl: linkToCarfax(),
    },
    {
      linkText: translations.footer.read,
      linkUrl: linkToReadOpensooq(),
      target: "_blank",
    },
    {
      linkText: translations.footer.areaGuide,
      linkUrl: linkToAreaGuideOpensooq(),
      target: "_blank",
    },
    {
      linkText: locale === "ar" ? translations.footer.blog : "",
      linkUrl: locale === "ar" ? linkToBlogOpensooq() : "",
      target: "_blank",
    },

    getCustomThemeValue("palestineRadiosPage") && {
      id: 14,
      linkText: translations.footer.palestineRadios,
      linkUrl: linkToPalestineRadios(),
      target: "_blank",
    },
    getCustomThemeValue("currencyRatesPage") && {
      id: 15,
      linkText: translations.footer.currencyRates,
      linkUrl: linkToCurrencyRates(),
      target: "_blank",
    },
    getCustomThemeValue("daleelsPage") && {
      id: 16,
      linkText: translations.footer.commercialDaleel,
      linkUrl: linkToCommercialDaleel(),
      target: "_blank",
    },
    getCustomThemeValue("mediclesPage") && {
      id: 17,
      linkText: translations.footer.medicleDaleel,
      linkUrl: linkToMedicleDaleel(),
      target: "_blank",
    },
    getCustomThemeValue("craftsPage") && {
      id: 18,
      linkText: translations.footer.crafts,
      linkUrl: linkToCrafts(),
      target: "_blank",
    },
    getCustomThemeValue("universitiesPage") && {
      id: 19,
      linkText: translations.footer.universities,
      linkUrl: linkToUniversities(),
      target: "_blank",
    },
    getCustomThemeValue("vaccinationsPage") && {
      id: 20,
      linkText: translations.footer.vaccinations,
      linkUrl: linkToVaccinations(),
      target: "_blank",
    },
    getCustomThemeValue("palestinianUniversitiesPage") && {
      id: 21,
      linkText: translations.footer.palestinianUniversities,
      linkUrl: linkToPalestinianUniversities(),
      target: "_blank",
    },
    getCustomThemeValue("gradesPage") && {
      id: 21,
      linkText: translations.footer.palestinianGrades,
      linkUrl: linkToPalestinianGrades(),
      target: "_blank",
    },
    {
      id : 22,
      linkText: translations.footer.brands,
      linkUrl: linkToBrandsPage(locale),
    },
  ];

  return linksList;
};

export const footerAboutLinks = (translations, locale, country) => {
  const countrySubDomain =
    parseCookies()?.[CookiesConstants.COUNTRY] || country;

  return [
    {
      linkText: process.env.NEXT_PUBLIC_CUSTOM_THEME==="shobiddak"?translations.shobiddakFooter.shobiddak:translations.footer.opensooq,
      linkUrl: linkToAboutUs(),
    },
    {
      linkText: translations.footer.howToUse,
      linkUrl: linkToSupport(),
      target: "_blank",
    },
    {
      linkText: translations.footer.paymentMethods,
      linkUrl: linkToPaymentMethod(countrySubDomain, locale),
      target: "_blank",
    },
    {
      linkText: translations.footer.ads,
      linkUrl: linkToAdvertisingProducts(),
    },

    {
      linkText: translations.footer.siteMap,
      linkUrl: linkToSiteMapPage(),
    },
      getCustomThemeValue("opensooqLogoPage") && {
      linkText: translations.footer.openSooqLogo,
      linkUrl: linkToOpenSooqLogo(),
    },
    getCustomThemeValue("chooseCountryPage") && {
      id: 1,
      linkText: translations.footer.others,
      linkUrl: linkToChooseCountry(country, locale),
    },
  ];
};


export const footerPricesCalculatorsLinks = (translations, locale) => {
  return [
    {
      id: 4,
      linkText: translations.footer.carPrices,
      // @ts-ignore
      //linkUrl: linkToCarPricesSpecs({ make: null, model: null, year: null }),
      linkUrl: "https://autos.opensooq.com/ar/",
    },
    {
      id: 5,
      linkText: translations.footer.mobileSpecs,
      linkUrl: linkMobileTabletPrices(locale === "ar" ? "موبايل" : "mobile", {
        brand: null,
      }),
    },
    {
      id: 6,
      linkText: translations.footer.tabletSpecs,
      linkUrl: linkMobileTabletPrices(locale === "ar" ? "تابلت" : "tablet", {
        brand: null,
      }),
    },
    {
      id: 7,
      // not found
      linkText: translations.footer.realEstatePrices,
      linkUrl: linkToRealEstatePrices(),
    },
    {
      id: 8,
      linkText: translations.footer.buyVsRent,
      linkUrl: linkToBuyRentComparisonCalculator(),
    },

    {
      id: 11,
      linkText: translations.footer.LoanCalculator,
      linkUrl: linkToLoanCalculator(),
    },
  ];
};
